import type { paths } from "../generated-api/schema";

type ProfileOptions =
  paths["/v1/profile-options"]["get"]["responses"][200]["content"]["application/json"];

/**
 * Offline review-artifact copy of the canonical Phase 2 catalogue choices.
 * The connected Admin always reads /v1/profile-options from the backend.
 */
export const demoProfileOptions: ProfileOptions = {
  interests: [
    { id: "NATURE_OUTDOORS", label: "Nature & Outdoors" },
    { id: "CULTURE_HISTORY", label: "Culture & History" },
    { id: "FOOD_DINING", label: "Food & Dining" },
    { id: "WELLNESS_RELAXATION", label: "Wellness & Relaxation" },
    { id: "ART_CREATIVITY", label: "Art & Creativity" },
    { id: "ADVENTURE_ACTIVE", label: "Adventure & Active" },
    { id: "NIGHTLIFE_SOCIAL", label: "Nightlife & Social" },
    { id: "LEARNING_WORKSHOPS", label: "Learning & Workshops" },
    { id: "SIGHTSEEING_TOURS", label: "Sightseeing & Tours" },
  ],
  travelStyles: [
    { id: "SLOW_RELAXED", label: "Slow & Relaxed" },
    { id: "ADVENTUROUS", label: "Adventurous" },
    { id: "CULTURAL_IMMERSION", label: "Cultural Immersion" },
    { id: "FOODIE", label: "Foodie" },
    { id: "WELLNESS_FOCUSED", label: "Wellness-Focused" },
    { id: "BUDGET_CONSCIOUS", label: "Budget-Conscious" },
    { id: "SPONTANEOUS", label: "Spontaneous" },
    { id: "PLANNED_ORGANIZED", label: "Planned & Organized" },
    { id: "LUXURY", label: "Luxury" },
    { id: "DIGITAL_NOMAD", label: "Digital Nomad" },
  ],
  // These choices are not consumed by the Admin catalogue editor. They stay
  // empty in the offline artifact instead of duplicating large member datasets.
  openTo: [],
  countries: [],
  languages: [],
};
